module.exports = "/lucky-balls/img/drum/drum_loop_042.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_042.png
// module id = 1057
// module chunks = 0